var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAdultForums(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAdultForums") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-706.000000, -1296.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.8131,1299 C722.63095,1299 723,1299.6211 723,1300.47838 L723,1306.37032 C723,1307.22963 722.63095,1308.09297 721.8131,1308.09297 L721.71135,1308.09297 L722.0958,1310 L719.4448,1308.09297 L713.61535,1308.09297 C712.79695,1308.09297 712,1307.22761 712,1306.37032 L712,1306.07424 L719.96345,1306.07424 C720.88855,1306.07424 721.35,1305.19744 721.35,1304.22778 L721.35,1299 L721.8131,1299 Z M719.131923,1296 C720.102885,1296 721,1296.86043 721,1297.6898 L721,1298.96377 L721,1304.36158 C721,1305.19038 720.103462,1305.77761 719.131923,1305.77761 L711.053846,1305.77761 L707.264615,1308 L707.855962,1305.76208 C706.947308,1305.67696 706,1305.12538 706,1304.36158 L706,1297.6898 C706,1296.86043 707.118077,1296 708.089615,1296 L719.131923,1296 Z",
    id: "icAdultForums"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdultForums);
export default __webpack_public_path__ + "static/media/icAdultForums.0c3efa494ce8ed9dca19b334b7f5711f.svg";
export { ForwardRef as ReactComponent };